module.exports = {
	"the_guco": "A Guco",
	"cases": "Cases",
	"projects": "Projetos",
	"clients": "Clientes",
	"contact": "Contato",
	"all": "Todos",
	"apps": "Apps",
	"systems": "Sistemas",
	"sites": "Sites",
	"ecommerce": "Loja Virtual",
	"ecommerces": "Lojas Virtuais",
	"name": "Nome",
	"phone": "Telefone",
	"email": "E-mail",
	"message": "Mensagem",
	"address": "Endereço",
	"contacts": "Contatos",
	"site_system": "Site/Sistema",
	"app": "App",
	"site": "Site",
	"system": "Sistema",
	"messages": {
		"menu_about_text": "Saiba mais sobre a agência",
		"menu_cases_text": "Uns baita projetos bacanas",
		"menu_projects_text": "Confira nossos trampos",
		"menu_clients_text": "Nossos clientes, parceiros e amigos",
		"menu_contact_text": "Venhar tomar um café conosco"
	},
	"sections": {
		"about": {
			"first_title": "Somos uma agência de criação e desenvolvimento que há 10 anos vem criando soluções inovadoras para nossos clientes.",
			"first_location": "Estamos situados em Sorocaba, mas graças a web (valeu <a href=\"https://www.w3.org/People/Berners-Lee\" target=\"_blank\">Tim Berners-Lee</a>) atendemos o mundo inteiro.",
			"first_text": "Amamos tecnologia (menos ASP.NET, <span class=\"tash\">brincadeira</span> … não, é sério) e apresentamos isso para nossos clientes sempre de forma clara e transparente, trazendo-o para fazer parte do nosso time durante o desenvolvimento de seu projeto.",
			"second_title": "Vamos entender o seu negócio e criar a melhor solução",
			"second_text": "Seja um app, sistema, site, e-commerce ou rede social (vai que você seja o idealizador de um novo facebook) com a melhor performance e estrutura (amamos código limpo e bem escrito). Estamos sempre em crescimento e entendemos que seu negócio também expandirá, por isso pensamos sempre em desenvolver ferramentas escaláveis de forma que não tenha maiores dificuldades em ampliar ou implementar novas funcionalidades.",
			"third_title": "Somos usuários e não nos esquecemos disso na hora de desenvolver nossos projetos, por isso pensamos sempre na melhor experiência do usuário (UX) e usabilidade da ferramenta (nunca deixaremos você dar dois cliques se pode dar apenas um)",
			"third_text": "Também fazemos ótimos cafés, venha conhecer a gente"
		},
		"cases": {
			"title": "<span>C</span><span>A</span><span>S</span><span>E</span><span>S</span>"
		},
		"projects": {
			"title": "<span>P</span><span>R</span><span>O</span><span>J</span><span>E</span><span>T</span><span>O</span><span>S</span>"
		},
		"contact": {
			"form": {
				"title": "Faça seu contato",
				"sub": "pelo formulário abaixo:"
			},
			"for_further_info": "Para mais informações sobre nossos serviços e orçamentos, entre em contato."
		},
		"loading": {
			"title": "<span>C</span><span>A</span><span>R</span><span>R</span><span>E</span><span>G</span><span>A</span><span>N</span><span>D</span><span>O</span>"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/pt-BR.json
// module id = 66
// module chunks = 0